import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/min-main-logo.png';
import _imports_1 from '../assets/search.png';
import _imports_2 from '../assets/GPS.png';
var _hoisted_1 = { class: "find-bike" };
var _hoisted_2 = { class: "back-button" };
var _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "home-logo" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_0,
        alt: ""
    })
], -1);
var _hoisted_4 = { class: "toggle-button" };
var _hoisted_5 = ["src"];
var _hoisted_6 = /*#__PURE__*/ _createTextVNode(" 租車 ");
var _hoisted_7 = ["src"];
var _hoisted_8 = /*#__PURE__*/ _createTextVNode(" 還車 ");
var _hoisted_9 = { class: "search-input" };
var _hoisted_10 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    alt: "搜尋"
}, null, -1);
var _hoisted_11 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_2,
    alt: ""
}, null, -1);
var _hoisted_12 = /*#__PURE__*/ _createElementVNode("p", null, "附近", -1);
var _hoisted_13 = [
    _hoisted_11,
    _hoisted_12
];
var _hoisted_14 = { class: "footer" };
var _hoisted_15 = ["src"];
var _hoisted_16 = /*#__PURE__*/ _createTextVNode(" 租車 ");
var _hoisted_17 = ["src"];
var _hoisted_18 = /*#__PURE__*/ _createTextVNode(" 還車 ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold");
    var _component_el_icon = _resolveComponent("el-icon");
    var _component_router_link = _resolveComponent("router-link");
    var _component_el_button = _resolveComponent("el-button");
    var _component_el_button_group = _resolveComponent("el-button-group");
    var _component_CustomSelect = _resolveComponent("CustomSelect");
    var _component_el_input = _resolveComponent("el-input");
    var _component_FindBikeMap = _resolveComponent("FindBikeMap");
    var _component_BaseLayout = _resolveComponent("BaseLayout");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_BaseLayout, null, {
            header: _withCtx(function () { return [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_router_link, { to: "/" }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_el_icon, null, {
                                default: _withCtx(function () { return [
                                    _createVNode(_component_ArrowLeftBold)
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    })
                ]),
                _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(function () { return [
                        _hoisted_3
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_button_group, null, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_el_button, {
                                class: _normalizeClass({ active: _ctx.searchType === 'Rent' }),
                                onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.searchType = 'Rent'); })
                            }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("img", {
                                        src: require("../assets/head-" + (_ctx.searchType === 'Rent' ? 'active' : 'inactive') + "-rent.png")
                                    }, null, 8, _hoisted_5),
                                    _hoisted_6
                                ]; }),
                                _: 1
                            }, 8, ["class"]),
                            _createVNode(_component_el_button, {
                                class: _normalizeClass({ active: _ctx.searchType === 'Return' }),
                                onClick: _cache[1] || (_cache[1] = function ($event) { return (_ctx.searchType = 'Return'); })
                            }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("img", {
                                        src: require("../assets/head-" + (_ctx.searchType === 'Return' ? 'active' : 'inactive') + "-return.png"),
                                        alt: ""
                                    }, null, 8, _hoisted_7),
                                    _hoisted_8
                                ]; }),
                                _: 1
                            }, 8, ["class"])
                        ]; }),
                        _: 1
                    })
                ])
            ]; }),
            body: _withCtx(function () { return [
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_CustomSelect, {
                        width: "123px",
                        height: "44px",
                        options: _ctx.taiwanLocationList,
                        onInput: _ctx.getSelectedOption,
                        default: "選擇縣市"
                    }, null, 8, ["options", "onInput"]),
                    _createVNode(_component_el_input, {
                        placeholder: "尋找站點",
                        modelValue: _ctx.searchInput,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((_ctx.searchInput) = $event); })
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.onSearch
                    }, {
                        default: _withCtx(function () { return [
                            _hoisted_10
                        ]; }),
                        _: 1
                    }, 8, ["onClick"])
                ]),
                _createElementVNode("div", {
                    class: "gps-search",
                    onClick: _cache[3] || (_cache[3] =
                        //@ts-ignore
                        function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            return (_ctx.getLocation && _ctx.getLocation.apply(_ctx, args));
                        })
                }, _hoisted_13),
                _createVNode(_component_FindBikeMap, {
                    currentPosition: _ctx.currentPosition,
                    searchType: _ctx.searchType
                }, null, 8, ["currentPosition", "searchType"])
            ]; }),
            footer: _withCtx(function () { return [
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["footer-button", { active: _ctx.searchType === 'Rent' }]),
                        onClick: _cache[4] || (_cache[4] = function ($event) { return (_ctx.searchType = 'Rent'); })
                    }, [
                        _createElementVNode("img", {
                            src: require("../assets/" + (_ctx.searchType === 'Rent' ? 'active' : 'inactive') + "-rent.png"),
                            alt: ""
                        }, null, 8, _hoisted_15),
                        _hoisted_16
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["footer-button", { active: _ctx.searchType === 'Return' }]),
                        onClick: _cache[5] || (_cache[5] = function ($event) { return (_ctx.searchType = 'Return'); })
                    }, [
                        _createElementVNode("img", {
                            src: require("../assets/" + (_ctx.searchType === 'Return' ? 'active' : 'inactive') + "-return.png"),
                            alt: ""
                        }, null, 8, _hoisted_17),
                        _hoisted_18
                    ], 2)
                ])
            ]; }),
            _: 1
        })
    ]));
}
